"use strict";
exports.__esModule = true;
exports.Events = exports.TaskType = exports.InteractionType = exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType["BUTTON"] = "BUTTON";
    ComponentType["CARD_OR_SECTION"] = "CARD_OR_SECTION";
    ComponentType["VIDEO"] = "VIDEO";
    ComponentType["FREE_TEXT_BOX"] = "FREE_TEXT_BOX";
    ComponentType["OPTION"] = "OPTION";
    ComponentType["TASK_LIST"] = "TASK_LIST";
    ComponentType["TASK_ONE_LINE"] = "TASK_ONE_LINE";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var InteractionType;
(function (InteractionType) {
    InteractionType["CLICK"] = "CLICK";
    InteractionType["EXPAND"] = "EXPAND";
    InteractionType["COLLAPSE"] = "COLLAPSE";
    InteractionType["SCROLL"] = "SCROLL";
    InteractionType["TYPING"] = "TYPING";
    InteractionType["SELECT"] = "SELECT";
})(InteractionType = exports.InteractionType || (exports.InteractionType = {}));
var TaskType;
(function (TaskType) {
    TaskType["EXERCISE_FEEDBACK"] = "EXERCISE_FEEDBACK";
    TaskType["EXERCISE_PERFORMANCE_EVAL"] = "EXERCISE_PERFORMANCE_EVAL";
    TaskType["CHECK_IN_VIDEO"] = "CHECK_IN_VIDEO";
})(TaskType = exports.TaskType || (exports.TaskType = {}));
var Events;
(function (Events) {
    var ScreenShown = (function () {
        function ScreenShown(struct) {
            this.struct = struct;
            this.name = 'Screen Shown';
            this.props = Object.freeze({
                schema_version: 2,
                url: this.struct.url,
                screen_name: this.struct.screen_name
            });
        }
        return ScreenShown;
    }());
    Events.ScreenShown = ScreenShown;
    var ComponentShown = (function () {
        function ComponentShown(struct) {
            this.struct = struct;
            this.name = 'Component Shown';
            this.props = Object.freeze({
                schema_version: 2,
                component_type: this.struct.component_type,
                component_name: this.struct.component_name,
                component_value: this.struct.component_value,
                url: this.struct.url,
                screen_name: this.struct.screen_name
            });
        }
        return ComponentShown;
    }());
    Events.ComponentShown = ComponentShown;
    var InteractionTaken = (function () {
        function InteractionTaken(struct) {
            this.struct = struct;
            this.name = 'Interaction Taken';
            this.props = Object.freeze({
                schema_version: 2,
                url: this.struct.url,
                insteraction_type: this.struct.insteraction_type,
                component_type: this.struct.component_type,
                component_name: this.struct.component_name,
                component_value: this.struct.component_value,
                interaction_value: this.struct.interaction_value
            });
        }
        return InteractionTaken;
    }());
    Events.InteractionTaken = InteractionTaken;
    var TaskAssigned = (function () {
        function TaskAssigned(struct) {
            this.struct = struct;
            this.name = 'Task Assigned';
            this.props = Object.freeze({
                schema_version: 2,
                task_type: this.struct.task_type,
                task_title: this.struct.task_title,
                task_id: this.struct.task_id,
                task_status: this.struct.task_status
            });
        }
        return TaskAssigned;
    }());
    Events.TaskAssigned = TaskAssigned;
    var TaskOpened = (function () {
        function TaskOpened(struct) {
            this.struct = struct;
            this.name = 'Task Started';
            this.props = Object.freeze({
                schema_version: 2,
                task_type: this.struct.task_type,
                task_title: this.struct.task_title,
                task_id: this.struct.task_id,
                task_status: this.struct.task_status
            });
        }
        return TaskOpened;
    }());
    Events.TaskOpened = TaskOpened;
    var TaskFinished = (function () {
        function TaskFinished(struct) {
            this.struct = struct;
            this.name = 'Task Finished';
            this.props = Object.freeze({
                schema_version: 2,
                task_type: this.struct.task_type,
                task_title: this.struct.task_title,
                task_id: this.struct.task_id,
                task_status: this.struct.task_status
            });
        }
        return TaskFinished;
    }());
    Events.TaskFinished = TaskFinished;
})(Events = exports.Events || (exports.Events = {}));
//# sourceMappingURL=tutor-event-schema.js.map